import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, FormattedNumber } from 'react-intl';

const messagesData = defineMessages({
  oneHour: {
    id: 'shared_components.response_time.within_1_hour',
    defaultMessage: 'within 1 hr'
  },
  anyHours: {
    id: 'shared_components.response_time.within_any_hours',
    defaultMessage: 'within {hours} hrs'
  },
  overHours: {
    id: 'shared_components.response_time.in_over_',
    defaultMessage: 'in over {hours} hrs'
  }
});

const ResponseTime = ({ hours }) => {
  if (1 === hours) {
    return <FormattedMessage { ...messagesData.oneHour } />;
  } else if (9 > hours) {
    return <FormattedMessage { ...messagesData.anyHours } values={{ hours: <FormattedNumber value={hours} /> }} />;
  } else if (13 > hours) {
    return <FormattedMessage { ...messagesData.anyHours } values={{ hours: <FormattedNumber value={12} /> }} />;
  } else if (25 > hours) {
    return <FormattedMessage { ...messagesData.anyHours } values={{ hours: <FormattedNumber value={24} /> }} />;
  } else if (49 > hours) {
    return <FormattedMessage { ...messagesData.anyHours } values={{ hours: <FormattedNumber value={48} /> }} />;
  }
  return <FormattedMessage { ...messagesData.overHours } values={{ hours: <FormattedNumber value={48} /> }} />;
};

ResponseTime.propTypes = {
  hours: PropTypes.number.isRequired
};

export default ResponseTime;
